import { render, staticRenderFns } from "./SpaceAuth.vue?vue&type=template&id=5c8a5678&scoped=true"
import script from "./SpaceAuth.vue?vue&type=script&lang=js"
export * from "./SpaceAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a5678",
  null
  
)

export default component.exports